import { render, staticRenderFns } from "./CallDetailIncomingInfo.vue?vue&type=template&id=4c8cbb6a&"
import script from "./CallDetailIncomingInfo.vue?vue&type=script&lang=ts&"
export * from "./CallDetailIncomingInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports